import { createAction, props } from '@ngrx/store';

import { ProposalDocument } from '@lockton-apps/shared/interfaces';

export enum ProposalDocumentsApiActionTypes {
  LoadSuccess = '[ProposalDocuments API] Load Success',
  LoadFailure = '[ProposalDocuments API] Load Failure',
  LoadAllSuccess = '[ProposalDocuments API] Load All Success',
  LoadAllFailure = '[ProposalDocuments API] Load All Failure',
  CreatedSuccess = '[ProposalDocuments API] Created Success',
  CreatedFailure = '[ProposalDocuments API] Created Failure',
  UpdatedSuccess = '[ProposalDocuments API] Updated Success',
  UpdatedFailure = '[ProposalDocuments API] Updated Failure',
}

export const ProposalDocumentsApiActions = {
  loadSuccess: createAction(
    ProposalDocumentsApiActionTypes.LoadSuccess,
    props<{ document: ProposalDocument }>()
  ),
  loadFailure: createAction(
    ProposalDocumentsApiActionTypes.LoadFailure,
    props<{ error: ProposalDocument }>()
  ),
  loadAllSuccess: createAction(
    ProposalDocumentsApiActionTypes.LoadAllSuccess,
    props<{ documents: ProposalDocument[] }>()
  ),
  loadAllFailure: createAction(
    ProposalDocumentsApiActionTypes.LoadAllFailure,
    props<{ error: ProposalDocument }>()
  ),
  createdSuccess: createAction(
    ProposalDocumentsApiActionTypes.CreatedSuccess,
    props<{ document: ProposalDocument }>()
  ),
  createdFailure: createAction(
    ProposalDocumentsApiActionTypes.CreatedFailure,
    props<{ error: ProposalDocument }>()
  ),
  updatedSuccess: createAction(
    ProposalDocumentsApiActionTypes.UpdatedSuccess,
    props<{ document: ProposalDocument }>()
  ),
  updatedFailure: createAction(
    ProposalDocumentsApiActionTypes.UpdatedFailure,
    props<{ error: ProposalDocument }>()
  ),
};
